var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          ref: "select",
          attrs: {
            filterable: _vm.filterable,
            clearable: _vm.clearable,
            placeholder: _vm.placeholder,
            remote: _vm.remote,
            "remote-method": _vm.setQuery,
          },
          model: {
            value: _vm.curValue,
            callback: function ($$v) {
              _vm.curValue = $$v
            },
            expression: "curValue",
          },
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.computedOptions, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: {
          label: item.label,
          value: item.value,
          disabled: _vm.disable(item),
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }